import {
  Box,
  Button,
  Flex,
  Group,
  Modal,
  Text,
  Tooltip,
  rem,
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import { Dropzone } from "@mantine/dropzone";
import {
  fileStatus,
  updateFiles,
  uploadFiles,
  uploadToTemplate,
} from "../../services/Document";
import { useSelector } from "react-redux";
import { DatePickerInput } from "@mantine/dates";
import moment from "moment";
import EmptyUploadFile from "../Svgs/EmptyUploadFile";
import DateSvg from "../Svgs/DateSvg";
import useStyles from "./style";
import { FaRegFile } from "react-icons/fa6";
import swal from "sweetalert";
import { getNotifications } from "../../services/notification";
import { getComplianceDashboard } from "../../services/compliance";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { setUploadDocModal } from "../../store/reducers/document";
import store from "../../store";
import { formatFileSize, showError } from "../../utils";
import { uploadFileToS3Api } from "../../utils/PresignedUrlFunction";
import "@cyntler/react-doc-viewer/dist/index.css";
import { getPendingActions } from "../../services/dashboard";

/**
 * Component to upload files to a selected folder or create a new one.
 *
 * @param {Object} props - Component props
 * @param {Object} props.selectedFolder - selected folder object
 * @param {string} props.userId - user id
 * @param {string} props.userType - user type (staff, client, facility)
 * @param {boolean} props.isPendingAction - whether the action is pending
 * @param {Object} props.uploadedFiles - uploaded files object
 * @param {boolean} props.isnotificationdoc - whether the file is from notification
 */
const UploadStaffDocDashboard = ({
  selectedFolder,
  userId,
  userType,
  isPendingAction,
  uploadedFiles,
  isnotificationdoc,
}) => {
  const { classes } = useStyles();
  // const [opened, setOpen] = useState(false);
  const { uploadFileLoading, uploadDocModal } = useSelector(
    (state) => state.document
  );
  const { updateFileLoading } = useSelector((state) => state.document);
  const [files, setFiles] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [expiryDates, setExpiryDates] = useState([]);
  const [confirmClearOpen, setConfirmClearOpen] = useState(false);
  const [fileSizeError, setFileSizeError] = useState("");

  const close = () => {
    // setOpen(false);
    store.dispatch(setUploadDocModal(false));
    setFiles([]);
    setExpiryDates([]);
    setSelectedFile(null);
  };
  // const open = () => setOpen(true);

  useEffect(() => {
    if (isnotificationdoc) {
      // setOpen(true);
      store.dispatch(setUploadDocModal(true));
    }
  }, [isnotificationdoc]);

  const remove = (id, _index) => {
    setFiles((p) => {
      return p?.filter((v) => v?.name !== id);
    });
    let _tempDates = expiryDates;
    _tempDates = _tempDates?.splice(_index, 1);
    setExpiryDates(_tempDates);
    setSelectedFile(null);
  };

  const unsupportedTypes = [
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];
  const fileType = selectedFile?.type;

  const Content = () => {
    const handleFileDrop = async (newFiles) => {
      setFileSizeError("");
      try {
        // Upload to S3
        const uploadedToS3 = await Promise.all(
          newFiles.map(async (file) => {
            const result = await uploadFileToS3Api({ file });
            return {
              name: file.name,
              url: result?.uploadURL,
              size: file.size,
              type: file.type,
            };
          })
        );

        // Merge with existing
        const updatedFiles = [...files, ...uploadedToS3];
        setFiles(updatedFiles);

        // Preview ke liye first select karo agar koi selected file nahi hai
        if (!files?.length) {
          setSelectedFile(updatedFiles[0]);
        }
      } catch (error) {
        showError(error?.message || "File upload to S3 failed");
      }
    };

    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div className={classes.uploadFileContainer} style={{ flex: 1 }}>
          {/* <Flex></Flex> */}
          <div className={classes.dropzone}>
            <Dropzone
              multiple={false}
              onDrop={handleFileDrop}
              onReject={(files) => {
                // setFileSizeError("File cannot be larger than 1MB");
              }}
              // maxSize={1 * 1024 ** 2} // 1mb file size
              // accept={IMAGE_MIME_TYPE}
            >
              <Group
                position="center"
                spacing="xl"
                style={{ minHeight: rem(220), pointerEvents: "none" }}
              >
                <Dropzone.Accept></Dropzone.Accept>
                <Dropzone.Reject></Dropzone.Reject>
                <Dropzone.Idle></Dropzone.Idle>

                <Flex direction="column" align="center">
                  <EmptyUploadFile />
                  <Text size="md" inline>
                    <u>Click to Upload</u> or Drag and Drop
                  </Text>
                  {/* <Text
                    size="12px"
                    color="#979797"
                    ff={"Inter"}
                    fw={500}
                    inline
                    mt={7}
                  >
                    Maximum File Size 1MB
                  </Text> */}
                </Flex>
              </Group>
            </Dropzone>
            {fileSizeError && (
              <Text color="red" size="sm" mt={10}>
                {fileSizeError}
              </Text>
            )}

            {isPendingAction && files?.length > 1 && (
              <Text color="red" size="sm" mt={10}>
                You can only update one file at a time.
              </Text>
            )}
          </div>
          <Flex ml={20} justify={"flex-start"}>
            <Text>File Upload</Text>
          </Flex>
          {!files?.length && uploadedFiles ? (
            <Box className={classes.row}>
              <Box className={classes.column2}>
                <Box className={classes.fileItem}>
                  <Flex align={"center"} gap={5}>
                    <FaRegFile size={15} />
                    <Tooltip label={uploadedFiles?.name}>
                      <Text lineClamp={1} w={180}>
                        {uploadedFiles?.name}
                      </Text>
                    </Tooltip>
                  </Flex>
                  <Text lineClamp={1} w={180} className={classes.fileSize}>
                    {/* {`Size ${value?.size}`} */}
                  </Text>
                </Box>
              </Box>

              <Box className={classes.column2}>
                <Box className={classes.fileExpiryContainer}>
                  <Box className={classes.fileName}>
                    <Text fw={600} ff={"Inter"} fz={14}>
                      Expiry Date:
                    </Text>
                    <Text>
                      {moment(uploadedFiles?.expiry)?.format("MM/DD/YYYY")}
                    </Text>
                  </Box>
                  {/* <img
                    src="/assets/images/deleteFolder.png"
                    alt="delete"
                    style={{ width: 30, cursor: "pointer" }}
                    onClick={() => {
                      remove(value?.name);
                      expiryDates?.splice(1, index);
                      setExpiryDates([...expiryDates]);
                    }}
                  /> */}
                </Box>
              </Box>
            </Box>
          ) : null}
          {files?.length ? (
            <Box className={classes.row} style={{ width: "100%" }}>
              <Box className={classes.column2} style={{ width: "100%" }}>
                {files?.map((value, index) => (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: selectedFile ? "column" : "row",
                      justifyContent: selectedFile ? "flex-start" : "center",
                      alignItems: selectedFile ? "start" : "center",
                      marginLeft: selectedFile && "10px",
                    }}
                  >
                    <Box
                      className={classes.fileItem}
                      key={index}
                      onClick={() => setSelectedFile(value)}
                    >
                      <Flex align={"center"} gap={5}>
                        <FaRegFile size={15} />
                        <Tooltip label={value?.name}>
                          <Text lineClamp={1} w={180}>
                            {value?.name}
                          </Text>
                        </Tooltip>
                      </Flex>
                      <Text lineClamp={1} w={180} className={classes.fileSize}>
                        {`Size ${formatFileSize(value?.size)}`}
                      </Text>
                    </Box>

                    <Box className={classes.dateDeleteContainer}>
                      <Box
                        className={classes.dateContainer}
                        style={{ width: selectedFile && "250px" }}
                      >
                        <DatePickerInput
                          radius={"md"}
                          key={index}
                          label="Expiring Date"
                          size="sm"
                          value={
                            expiryDates?.[index]
                              ? new Date(expiryDates?.[index])
                              : null
                          }
                          onChange={(date) => {
                            let temp = [...expiryDates];
                            temp[index] = moment(date).toISOString();
                            setExpiryDates([...temp]);
                          }}
                          placeholder="Pick a date"
                          icon={<DateSvg />}
                          mx="auto"
                          className={classes.datePicker}
                        />
                      </Box>
                      <div
                        style={{ background: "var(--app-tint-red)", borderRadius: "100%" }}
                      >
                        <img
                          src="/assets/images/deleteFolder.png"
                          alt="delete"
                          style={{ width: 30, cursor: "pointer" }}
                          onClick={() => {
                            remove(value?.name, index);
                            expiryDates?.splice(1, index);
                            setExpiryDates([...expiryDates]);
                          }}
                        />
                      </div>
                    </Box>
                  </div>
                ))}
              </Box>

              {/* <Box className={classes.column2}>
                {files?.map((value, index) => (
                  <Box className={classes.dateDeleteContainer}>
                    <Box
                      className={classes.dateContainer}
                      style={{ width: selectedFile && "250px" }}
                    >
                      <DatePickerInput
                        radius={"md"}
                        key={index}
                        label="Expiring Date"
                        size="sm"
                        value={
                          expiryDates?.[index]
                            ? new Date(expiryDates?.[index])
                            : null
                        }
                        onChange={(date) => {
                          let temp = [...expiryDates];
                          temp[index] = moment(date).toISOString();
                          setExpiryDates([...temp]);
                        }}
                        placeholder="Pick a date"
                        icon={<DateSvg />}
                        mx="auto"
                        className={classes.datePicker}
                      />
                    </Box>
                    <img
                      src="/assets/images/deleteFolder.png"
                      alt="delete"
                      style={{ width: 30, cursor: "pointer" }}
                      onClick={() => {
                        remove(value?.name, index);
                        expiryDates?.splice(1, index);
                        setExpiryDates([...expiryDates]);
                      }}
                    />
                  </Box>
                ))}
              </Box> */}
            </Box>
          ) : null}
        </div>

        {(selectedFile || uploadedFiles) && (
          <div
            style={{
              marginRight: "10px",
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              border: "1px solid var(--app-border)",
            }}
          >
            <p style={{ fontWeight: 600 }}>Document Preview</p>

            {unsupportedTypes.includes(fileType) && selectedFile ? (
              <Flex align={"center"} justifyContent={"center"} gap={5} h={550}>
                This file type is not supported for preview.
              </Flex>
            ) : (
              <DocViewer
                style={{
                  borderTop: "1px solid var(--app-border)",
                  width: "100%",
                  height: 550,
                  overflowY: "auto",
                }}
                config={{ header: { disableHeader: true } }}
                key={1}
                documents={[
                  selectedFile
                    ? {
                        uri: selectedFile.url, // Now using S3 URL instead of createObjectURL
                        fileType: selectedFile.url?.split(".").pop(),
                      }
                    : {
                        uri: uploadedFiles?.fileUrl,
                        fileType: uploadedFiles?.fileUrl?.split(".").pop(),
                      },
                ]}
                pluginRenderers={DocViewerRenderers}
              />
            )}
          </div>
        )}

        {/* {selectedFile && (
          <div
            style={{
              marginRight: "10px",
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              border: "1px solid #E4E4E7",
            }}
          >
            <p style={{ fontWeight: 600 }}>Document Preview</p>
            {unsupportedTypes?.includes(fileType) ? (
              <Flex align={"center"} justifyContent={"center"} gap={5} h={550}>
                This file type is not supported for preview.
              </Flex>
            ) : (
              <DocViewer
                style={{
                  borderTop: "1px solid #E4E4E7",
                  width: "100%",
                  height: 550,
                  overflowY: "auto",
                }}
                config={{ header: { disableHeader: true } }}
                key={1}
                documents={[
                  {
                    uri: URL.createObjectURL(selectedFile),
                    fileType: fileType,
                  },
                ]}
                pluginRenderers={DocViewerRenderers}
              />
            )}
          </div>
        )} */}
      </div>
    );
  };

  return (
    <div>
      {/* {!isnotificationdoc && (
        <Box>
          {isPendingAction ? (
            <Button
              variant="white"
              c="#000"
              ff="Inter"
              fz={12}
              fw={500}
              onClick={open}
            >
              View Details
            </Button>
          ) : (
            <Button
              leftIcon={<UploadFileSvg size={20} />}
              color="yellow"
              onClick={open}
              style={{ color: "black" }}
            >
              Upload Files
            </Button>
          )}
        </Box>
      )} */}

      <Modal
        // opened={opened}
        opened={uploadDocModal}
        shadow="md"
        overlayProps={{ blur: 3 }}
        onClose={close}
        className={classes.uploadModal}
        size={1000}
        withCloseButton={isPendingAction || isnotificationdoc ? true : false}
        zIndex={1000}
        centered
      >
        <Content />
        <Group grow m={10}>
          {isPendingAction ? (
            <Button
              fullWidth
              color="gray"
              variant="light"
              c={"var(--app-text)"}
              onClick={() => setConfirmClearOpen(true)}
              style={{ width: "50%" }}
            >
              Clear
            </Button>
          ) : isnotificationdoc ? (
            <Button
              fullWidth
              color="gray"
              variant="light"
              c={"var(--app-text)"}
              onClick={close}
              style={{ width: "50%" }}
            >
              Cancel
            </Button>
          ) : (
            <Button
              fullWidth
              color="gray"
              variant="light"
              c={"var(--app-text)"}
              onClick={close}
              style={{ width: "50%" }}
            >
              Cancel
            </Button>
          )}
          {uploadedFiles ? (
            <Button
              fullWidth
              disabled={files?.length !== 1}
              loading={updateFileLoading}
              onClick={async () => {
                try {
                  // files already uploaded to S3, use them directly
                  const uploadedFile = files[0];

                   const normalizedFolderId =
                    typeof selectedFolder === "object" &&
                    selectedFolder !== null
                      ? selectedFolder?.id
                      : selectedFolder;

                  const fileMeta = {
                    files: [uploadedFile],
                    ...(normalizedFolderId && { folderId: normalizedFolderId }),
                    // ...(selectedFolder && { folderId: selectedFolder?.id }),
                    ...(expiryDates?.length && { expiryDates }),
                  };

                  const getUserType = uploadedFiles?.client
                    ? "client"
                    : uploadedFiles?.staff
                    ? "staff"
                    : "facility";

                  let success;
                  if (uploadedFiles?.isTemplate) {
                    // Use upload-to-template endpoint to preserve isTemplate flag
                    success = await uploadToTemplate(
                      uploadedFiles?.id,
                      {
                        fileUrl: uploadedFile?.url,
                        fileName: uploadedFile?.name,
                        expiry: expiryDates?.[0] || null,
                      },
                      userId,
                      getUserType,
                      normalizedFolderId
                    );
                  } else {
                    success = await updateFiles(
                      fileMeta,
                      uploadedFiles?.id,
                      userId,
                      getUserType,
                      normalizedFolderId
                    );
                  }

                  if (success) {
                    setFiles([]);
                    setExpiryDates([]);
                    getNotifications({ page: 1, perPage: 10, client: "" });
                    getPendingActions();
                    getComplianceDashboard();
                    close();

                    await swal({
                      title: "File Updated Successfully",
                      text: "Your file has been updated successfully",
                      icon: "success",
                      dangerMode: false,
                    });
                  }
                } catch (error) {
                  showError(error?.message || "File update failed");
                }
              }}
              color="yellow"
              c="var(--app-on-primary)"
              style={{ width: "50%" }}
            >
              Update
            </Button>
          ) : (
            // <Button
            //   fullWidth
            //   disabled={files?.length > 1 || !files?.length}
            //   loading={updateFileLoading}
            //   onClick={async () => {
            //     const getUserType = Object.keys(uploadedFiles).includes("staff")
            //       ? "staff"
            //       : Object.keys(uploadedFiles).includes("client")
            //       ? "client"
            //       : "facility";
            //     // Prepare form data
            //     const formData = new FormData();
            //     files?.forEach((file) => formData.append("file", file));
            //     if (selectedFolder) {
            //       formData.append("folderId", selectedFolder);
            //     }
            //     formData.append("expiryDates", JSON.stringify(expiryDates));

            //     if (userType === "staff") {
            //       formData.append("staff", userId);
            //     } else if (userType === "client") {
            //       formData.append("client", userId);
            //     } else {
            //       formData.append("facility", userId);
            //     }

            //     // Call update service
            //     const success = await updateFiles(
            //       formData,
            //       uploadedFiles?.id,
            //       userId,
            //       getUserType,
            //       selectedFolder
            //     );

            //     if (success) {
            //       close();
            //       setFiles([]);
            //       setExpiryDates([]);
            //       getNotifications({
            //         page: null,
            //         perPage: null,
            //         client: "",
            //       });
            //       await swal({
            //         title: "File Updated Successfully",
            //         text: "Your file has been updated successfully",
            //         icon: "success",
            //         dangerMode: false,
            //       });
            //     }
            //   }}
            //   color="yellow"
            //   c="#000"
            //   style={{ width: "50%" }}
            // >
            //   Update
            // </Button>
            <Button
              fullWidth
              loading={uploadFileLoading}
              onClick={async () => {
                let formdata = new FormData();
                files?.map((file) => {
                  formdata.append("file", file);
                });
                if (selectedFolder) {
                  formdata.append("folderId", selectedFolder?.id);
                }
                formdata.append("expiryDates", JSON.stringify(expiryDates));
                if (userType === "staff") {
                  formdata.append("staff", userId);
                } else if (userType === "client") {
                  formdata.append("client", userId);
                } else {
                  formdata.append("facility", userId);
                }
                await uploadFiles(
                  formdata,
                  selectedFolder?._id,
                  userId,
                  userType
                );
                close();
                setFiles([]);
                setExpiryDates([]);
              }}
              color="yellow"
              c={"var(--app-on-primary)"}
              style={{ width: "50%" }}
            >
              Save
            </Button>
          )}
        </Group>
      </Modal>
      <Modal
        opened={confirmClearOpen}
        onClose={() => setConfirmClearOpen(false)}
        centered
        size="md"
        shadow="md"
        overlayProps={{ blur: 3 }}
        radius={"md"}
        zIndex={1000}
      >
        <Text ff={"Inter"} fw={400} fz="xl" ta={"center"}>
          You are about to clear this reminder.
        </Text>
        <Text ff={"Inter"} fw={400} fz="md" mb="md" ta={"center"}>
          No action will be taken on the item itself. This action will only
          remove the reminder from your dashboard. Are you sure you want to
          proceed?
        </Text>
        <Group position="center">
          <Button
            variant="default"
            radius={"md"}
            size="sm"
            onClick={() => setConfirmClearOpen(false)}
          >
            Cancel
          </Button>
          <Button
            size="sm"
            color="yellow"
            radius={"md"}
            onClick={async () => {
              const getUserType = Object.keys(uploadedFiles).includes("staff")
                ? "staff"
                : Object.keys(uploadedFiles).includes("client")
                ? "client"
                : "facility";
              fileStatus(uploadedFiles?.id, userId, getUserType, {
                deleted: true,
              });
              getNotifications({
                page: 1,
                perPage: 10,
                client: undefined,
              });
              getPendingActions()
              // getExpiredFiles();
              // await getFiles(userId, getUserType, selectedFolder?._id, "");

              setConfirmClearOpen(false);
              close(); // clear modal and reset files
            }}
          >
            Continue
          </Button>
        </Group>
      </Modal>
    </div>
  );
};

export default UploadStaffDocDashboard;
